<template>
  <div class="tile rounded-none sm:rounded-md shadow-none sm:shadow lg:p-6">
    <slot />
  </div>
</template>

<!-- Be sure to use this with a layout container that is full-width on mobile -->
